module.exports = __webpack_public_path__ + "static/Shoreline-14.732fbc36.jpg";